import type { ReactNode } from 'react';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div style={{ minHeight: '100dvh', background: 'var(--navy)', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: 420, margin: '0 auto' }}>
        <p style={{ color: '#fff', fontWeight: 700, fontSize: '1.4rem', textAlign: 'center' }}>
          Refer Now
        </p>
        <div className="card" style={{ marginTop: '1.5rem' }}>
          <h1>{title}</h1>
          {subtitle && <p className="muted">{subtitle}</p>}
          {children}
        </div>
        {footer && <div style={{ color: 'var(--on-navy-muted)', textAlign: 'center' }}>{footer}</div>}
      </div>
    </div>
  );
}
